import { render, staticRenderFns } from "./hydrospArticle.vue?vue&type=template&id=4f849228"
import script from "./hydrospArticle.vue?vue&type=script&lang=js"
export * from "./hydrospArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports